import { render, staticRenderFns } from "./BrandProfileRightItem.vue?vue&type=template&id=7e530b9f"
import script from "./BrandProfileRightItem.vue?vue&type=script&lang=js"
export * from "./BrandProfileRightItem.vue?vue&type=script&lang=js"
import style0 from "./BrandProfileRightItem.vue?vue&type=style&index=0&id=7e530b9f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports